<import-file [title]="'Import Claim'" [isGeneric]="false" [documentType]="documentType.ClaimPayee" [duplicateCheck]="true"></import-file>